import zPayExpenseStatementDialog from "@/components/zPayExpenseStatementDialog";
import CompanyService from "@/services/CompanyService";
import OrderService from "@/services/OrderService";
import PaymentService from "@/services/PaymentService";
import PersonService from "@/services/PersonService";
import moment from "moment";
import Vue from "vue";
import { mapActions } from "vuex";
export default {
  name: "PaymentHeader",
  components: {
    zPayExpenseStatementDialog
  },
  props: {
    debits: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      personService: new PersonService(),
      companyService: new CompanyService(),
      paymentService: new PaymentService(),
      orderService: new OrderService(),
      expenseDialog: false,
      items: [],
      totalValue: 0,
      company: {},
      loading: false,
      order: {},
      charges: [],
      show: false,
      chargeId: "",
      solicitations: true,
      pin: false,
      paymentMethod: false,
      paymentCanceled: false,
      paymentValue: 0,
      currency: "BRL",
      currentCharge: {},
      shouldShowMessage: false,
      loadingPayment: false
    };
  },
  async created() {
    this.loading = true;

    this.company = this.companyService.getCurrentCompany();
    this.$store.dispatch("$setCurrentCompany", this.company);

    const token =
      this.$route.query.chargeToken || this.$store.getters.getChargeToken;

    if (token != null) {
      this.$store.dispatch("$setChargeToken", token);
    }

    const localCharge = this.$store.getters.getCurrentCharge || {};

    this.charge =
      localCharge.token === token
        ? localCharge
        : (await this.orderService.getChargeByToken(token).catch(() => null)) ||
          {};

    this.$store.dispatch("$setCurrentCharge", this.charge);

    let localorder = this.$store.getters.getCurrentOrder;
    if (!localorder) {
      if (token != null) {
        try {
          if (this.charge) {
            this.$store.dispatch("$setCurrentCharge", this.charge);
            const orderId = this.charge.order.id;
            this.order = await this.orderService.getOrderById(orderId);
            this.$store.dispatch("$setCurrentOrder", this.order);
          } else {
            this.shouldShowMessage = true;
          }
        } catch (error) {
          if (error.status == 408) {
            this.$toaster.error(this.$t("INFRA.PORTAL_CUSTOM_ERRORS.PAY_422"));
            this.shouldShowMessage = true;
            this.loading = false;
          } else {
            this.shouldShowMessage = true;
            this.loading = false;
          }
        }
      } else {
        this.shouldShowMessage = true;
      }
    } else {
      this.order = localorder;
    }

    this.$store.dispatch("$setCurrentOrder", this.order);
    await this.loadCharges();
    if (this.shouldShowMessage == true) {
      this.$emit("showMessage");
    }
  },
  async mounted() {
    Vue.$globalEvent.$on("reload", async (reloadCharges = false) => {
      if (reloadCharges) {
        const token = this.$store.getters.getChargeToken;
        const pending = await this.orderService.getCharges(this.order.orderId, {
          status: "pending"
        });
        this.charges = (pending || []).filter(c => c.token === token);
      }
      this.$store.dispatch("$setIsValidated", false);
    });
  },
  computed: {
    checkinDate() {
      if (this.order) {
        return moment(this.order.metadata.checkinDate).format(
          this.$t("GLOBAL.DATE_FORMAT")
        );
      }
    },
    checkoutDate() {
      if (this.order) {
        return moment(this.order.metadata.checkoutDate).format(
          this.$t("GLOBAL.DATE_FORMAT")
        );
      }
    }
  },
  methods: {
    ...mapActions(["$setCurrentCharge", "$setIsValidated"]),
    openExpenseStatementDialog(charge) {
      this.items = charge.items;
      this.totalValue = charge.amount;
      this.expenseDialog = true;
    },
    async loadCharges() {
      if (this.order) {
        this.order.orderId = this.order.id || this.order._id;
        this.currency = this.order.currency || this.currency;

        let charges = await this.orderService.getCharges(this.order.orderId, {
          status: "pending"
        });
        // só a cobrança do token atual — charges[0] mostrava o valor de
        // outro hóspede quando o pedido é de grupo.
        const token = this.$store.getters.getChargeToken;
        this.charges = (charges || []).filter(c => c.token === token);
      }
      if (this.charges.length === 0) {
        this.shouldShowMessage = true;
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    goToCompleteRegister() {
      let token;
      let tokenValidTo;
      token = this.personService.getPersonToken();
      tokenValidTo = this.personService.getTokenExpiration();
      if (token && tokenValidTo) {
        this.$router.push("/user/profile");
      } else {
        this.$emit("toLogin");
      }
    }
  }
};
